import styled from 'styled-components';

export const Nav = styled.nav`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 23px 0;
  gap: 40px;
  border-radius: 0 35px 35px 0;
  transition: all 0.5s ease-in-out;

  &:hover {
    box-shadow: inset -40px 0 30px -20px rgba(255, 255, 255, 0.2);

    .button-hidden {
      opacity: 1;
    }
  }

  &[data-chat-enabled='true'] ul {
    padding-bottom: 7.25rem;
  }

  .cache,
  .version {
    position: absolute;
    left: 0;
    width: 100%;
    padding: 0;
    border: 0;
    color: white;
    background: transparent;
    text-align: center;
    cursor: pointer;
  }

  .cache {
    bottom: 30px;
    font-size: 13px;
  }

  .version {
    bottom: 10px;
    font-size: 11px;
  }
`;

export const ButtonHidden = styled.button`
  position: absolute;
  top: 0;
  right: 5px;
  display: flex;
  align-items: center;
  height: 100%;
  padding: 10px 5px;
  border: none;
  outline: none;
  opacity: 0;
  background: transparent;
  cursor: pointer;
  transition: opacity 0.5s ease-in-out;

  &:focus-visible {
    opacity: 1;
    outline: 0.1875rem solid var(--primary-action);
    outline-offset: 0.125rem;
  }
`;

export const LogoButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
`;

export const Logo = styled.img`
  width: 132px;
  height: 80px;
  opacity: 1;
  transition: opacity 0.5s ease-in-out;

  &.back-off {
    opacity: 0;
  }
`;

export const LeftArrow = styled.div`
  &.right {
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid white;
  }

  &.left {
    border-top: 5px solid transparent;
    border-right: 5px solid white;
    border-bottom: 5px solid transparent;
  }
`;
